import { getExternalBootstrapData } from "./utils/externalScriptBootstrap";

let _gameInstance: any;


export function registerGame(game: any) {
    _gameInstance = game;
}

export function startGame(config: any) {
    //Per settare le lingua all'avvio al gioco e comunico con il menu
    (window as any).UIBridge.setLanguage(config.params.language);
    (window as any).UIBridge.setCurrency(config.params.currency);
    (window as any).UIBridge.setCheatVisible(config.params.debug);
    (window as any).UIBridge.setHistoryVisible((window as any).GENERAL_CONFIG.EnableHistory)

    //Per settare la lingua agli html del gioco
    const langShort = config.params.language.split("_")[0]; //TODO Provare a renderlo unico insieme a quello di sopra
    (window as any).currentLang = langShort;
    (window as any).currentCurrency = config.params.currency;

    if (config.params.mode === "real") 
        (window as any).UIBridge.hideBanner();
    else 
        (window as any).UIBridge.showBanner();


    //console.log('starting...', config.params.language, config.params.currency, langShort, config.params.env);
    if (_gameInstance) {
        _gameInstance.gameInit(config.params, config.settings); //GameClient Game Init
    } else {
        console.error('No game registered!');
    }

    const bootstrapData = getExternalBootstrapData();

    if (bootstrapData?.type === "nyx") {
        console.log("[startGame] NYX bootstrap data:", bootstrapData);
        console.log("[startGame] _gameInstance:", _gameInstance);
        console.log("[startGame] window.gcm:", (window as any).gcm);
    }


    //Notifico solo all'avvio effettivo della valuta
    _gameInstance.notifyCurrencyChange(config.params.currency);
}

export function getGameInstance() {
    return _gameInstance;
}